<template>
  <div class="d-flex flex-wrap">
    <div
      v-for="item in inputItems"
      class="d-inline-flex mt-auto p-2 ps-0 text-start"
    >
      <!-- 日期 -->
      <commonDateInput
        v-if="item.type == 'date' || item.type == 'dateBetween'"
        v-model:getValue="item.getValue"
        :label="item.label"
        :type="item.type"
      ></commonDateInput>

      <!-- 文字 -->
      <commonTextInput
        v-else-if="item.type == 'text'"
        v-model:getValue="item.getValue"
        :label="item.label"
      ></commonTextInput>

      <!-- 選單 -->
      <commonSelectInput
        v-else-if="item.type == 'select'"
        v-model:getValue="item.getValue"
        :label="item.label"
        :options="item.options"
        :disableText="item.disableText"
        :disableLock="item.disableLock"
        :disableValue="item.disableValue"
      ></commonSelectInput>

      <!-- 選單 -->
      <commonSelectInputList
        v-else-if="item.type == 'selectInputList'"
        v-model:getValue="item.getValue"
        :label="item.label"
        :options="item.options"
        :disableText="item.disableText"
        :disableValue="item.disableValue"
      ></commonSelectInputList>

      <!-- 時間 -->
      <commonTimeInput
        v-else-if="item.type == 'time' || item.type == 'timeBetween'"
        :label="item.label"
        :type="item.type"
        v-model:getValue="item.getValue"
      ></commonTimeInput>

      <!-- 月份 -->
      <commonMonthInput
        v-else-if="
          item.type == 'month' ||
          item.type == 'monthBetween' ||
          item.type == 'singleMonth'
        "
        :label="item.label"
        :type="item.type"
        v-model:getValue="item.getValue"
      ></commonMonthInput>
    </div>

    <div v-if="!buttonHide" class="mt-auto p-2">
      <button
        type="button"
        class="btn btn-secondary"
        style="
          background-color: rgb(75, 140, 128);
          font-size: 1.125rem;
          height: 2rem;
          line-height: normal;
        "
        @click="submitQuery"
      >
        {{ buttonName }}
      </button>
    </div>
  </div>
</template>

<script>
import commonDateInput from "@/components/commonQueryInput/commonDateInput.vue";
import commonTimeInput from "@/components/commonQueryInput/commonTimeInput.vue";
import commonTextInput from "@/components/commonQueryInput/commonTextInput.vue";
import commonSelectInput from "@/components/commonQueryInput/commonSelectInput.vue";
import commonSelectInputList from "@/components/commonQueryInput/commonSelectInputList.vue";
import commonMonthInput from "@/components/commonQueryInput/commonMonthInput.vue";

import { isRef, ref } from "@vue/reactivity";
import { watch } from "@vue/runtime-core";
import { useStore } from "vuex";
export default {
  components: {
    commonDateInput,
    commonTimeInput,
    commonTextInput,
    commonSelectInput,
    commonSelectInputList,
    commonMonthInput,
  },
  props: {
    inputItems: Array,
    buttonHide: {
      type: Boolean,
      default: false,
    },
    buttonName: {
      type: String,
      default: "查詢",
    },
    immediateInputValues: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    //dispatch
    const methods = {
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const inputItems = ref(props.inputItems);
    const buttonHide = ref(props.buttonHide);
    const immediateInputValues = ref(props.immediateInputValues);

    /************** 初始化 inputItems  ****************/
    for (let i in inputItems.value) {
      let item = inputItems.value[i];
      //select的設定
      if (item.type == "select" || item.type == "selectInputList") {
        //沒有bindKey的select
        if (!item.bindKey) {
          continue;
        }
        //找出連結的物件
        const bindItem = inputItems.value.filter(
          (bItme) => bItme.key == item.bindKey
        );
        if (bindItem.length == 0) {
          console.error("'bindKey'沒有在inputItems中找到");
          return;
        }

        //watch 連結的物件的getValue改變
        watch(
          () => bindItem[0].getValue,
          (newValue) => {
            let bindOptions = [];
            if (isRef(item.bindOptions)) {
              if (
                typeof item.bindOptions.value != "object" ||
                Array.isArray(item.bindOptions.value)
              ) {
                console.error(
                  "InputItems有'bindKey'鍵,'bindOptions'需要為物件"
                );
                item.bindOptions.value = {};
              }
              bindOptions = item.bindOptions.value[newValue];
            } else {
              if (
                typeof item.bindOptions != "object" ||
                Array.isArray(item.bindOptions)
              ) {
                console.error(
                  "InputItems有'bindKey'鍵,'bindOptions'需要為物件"
                );
                item.bindOptions = {};
              }
              bindOptions = item.bindOptions[newValue];
            }
            item.options = bindOptions;
          },
          { deep: true }
        );

        //watch 連結的物件的bindOptions改變
        watch(
          () => item.bindOptions,
          (newValue) => {
            let bindKeyValue = undefined;
            for (let j in inputItems.value) {
              let watchItem = inputItems.value[j];
              if (item.bindKey == watchItem.key) {
                bindKeyValue = watchItem.getValue;
                break;
              }
            }
            if (newValue[bindKeyValue] != undefined) {
              item.options = newValue[bindKeyValue];
            }
          },
          { deep: true }
        );
      }
    }

    /************** 按查詢 ****************/
    const submitQuery = (event) => {
      let inputValue = {};
      for (let i in inputItems.value) {
        let item = inputItems.value[i];
        //檢查值是否為空(checkEmpty == true 時)
        if ("checkEmpty" in item && item.checkEmpty == true) {
          console.log(item.getValue);
          if (
            typeof item.getValue != "object" &&
            (item.getValue == undefined || item.getValue == "")
          ) {
            // console.log(item.key + ">> is Empty (alarm)");
            if (item.type == "select") {
              methods.setTimeoutAlert("請選擇" + item.label);
            } else {
              methods.setTimeoutAlert("請輸入" + item.label);
            }
            return;
          }
          for (const key in item.getValue) {
            if (item.getValue[key] == undefined || item.getValue[key] == "") {
              if (item.type == "select") {
                methods.setTimeoutAlert("請選擇" + item.label);
              } else {
                methods.setTimeoutAlert("請輸入" + item.label);
              }
              return;
            }
          }
        }

        //整理傳送的資料
        if (item.getValue) {
          inputValue[item.key] = item.getValue;
        }
      }

      emit("update:getValue", inputValue);
    };

    /************** 隱藏button 自動更新getValue ****************/
    if (buttonHide.value == true) {
      //watch 連結的物件的getValue改變
      watch(
        () => inputItems,
        () => {
          let inputValue = {};
          for (let i in inputItems.value) {
            let item = inputItems.value[i];
            //整理傳送的資料
            if (item.getValue) {
              inputValue[item.key] = item.getValue;
            }
          }
          emit("update:getValue", inputValue);
          // item.options = bindOptions;
        },
        { deep: true }
      );
    }

    /************** 自動更新getImmediateValue ****************/
    if (immediateInputValues.value == true) {
      //watch 連結的物件的getValue改變
      watch(
        () => inputItems,
        () => {
          let getImmediateValue = {};
          for (let i in inputItems.value) {
            let item = inputItems.value[i];
            //整理傳送的資料
            if (item.getValue) {
              getImmediateValue[item.key] = item.getValue;
            }
          }
          emit("update:getImmediateValue", getImmediateValue);
        },
        { deep: true }
      );
    }

    return {
      inputItems,
      submitQuery,
    };
  },
};
</script>

<style></style>

<!--範例

{
  key: "date",
  label: "日期",
  type: "dateBetween", // date/dateBetween/text/select/
},
{
  key: "workCode",
  label: "工單編號",
  type: "text", // date/dateBetween/text/select/
},
{
  key: "process",
  label: "制程",
  type: "select", // date/dateBetween/text/select/
  disableText: "-- 選擇制程 --",
  options: [
    {
      text: "打頭(橋頭廠)",
      value: "factory_one-5",
    },
    {
      text: "輾牙(橋頭廠)",
      value: "factory_one-6",
    },
    {
      text: "熱處理(橋頭廠)",
      value: "factory_one-7",
    },
  ],
},
{
  key: "device",
  label: "機台",
  type: "select", // date/dateBetween/text/select/
  bindKey: "process",
  disableText: "-- 選擇機台 --",
  options: {
    "factory_one-6": [
      {
        text: "R04",
        value: "R04",
      },
      {
        text: "R09",
        value: "R09",
      },
      {
        text: "S49",
        value: "S49",
      },
    ],
    "factory_one-5": [
      {
        text: "B01",
        value: "B01",
      },
      {
        text: "B02",
        value: "B02",
      },
      {
        text: "B05",
        value: "B05",
      },
      {
        text: "B06",
        value: "B06",
      },
    ],
    "factory_one-7": [
      {
        text: "A",
        value: "A",
      },
      {
        text: "B",
        value: "B",
      },
      {
        text: "C",
        value: "C",
      },
      {
        text: "D",
        value: "D",
      },
      {
        text: "E",
        value: "E",
      },
    ]
  },
},


-->
